/**
 * Where a fitted part comes off (piece 29, P29-16; decision 10320): the Add
 * Part window's van, shop and Another Site offers, and the Vans card on
 * Settings › Service › Dispatch Rules where a technician's van is assigned.
 */
export const PART_SOURCE_STRINGS = {
  'workOrder.part.van': 'Van',
  'workOrder.part.shop': 'Shop',
  'workOrder.part.another': 'Another Site',
  'workOrder.part.site': 'Site',
  'workOrder.part.onHand': 'on hand',
  'workOrder.part.noVan': 'No van is assigned to you, so the shop is offered first.',
  'workOrder.part.pickItem': 'Pick the part to see where it can come off.',
  'workOrder.part.service': 'A service comes off no shelf, so nothing is asked.',
  'workOrder.part.noSite': 'Pick where the part came off.',
  'settings.vans.title': 'Vans',
  'settings.vans.hint': 'A technician’s van is the first stock a part they fit is offered from. A new van closes the one before it on the day before it starts.',
  'settings.vans.assign': 'Assign Van',
  'settings.vans.none': 'No vans are assigned yet. Assign one with Assign Van.',
  'settings.vans.technician': 'Technician',
  'settings.vans.van': 'Van',
  'settings.vans.startDate': 'Start Date',
  'settings.vans.since': 'since',
  'settings.vans.by': 'by',
  'settings.vans.saved': 'Van assigned.',
  'settings.vans.raced': 'Somebody assigned this technician a van a moment ago, so nothing was written. Reload the card to see the van now in force.',
} as const;
